import { cn } from "@/lib/utils";
import { STATUS_LABELS, PRIORITY_LABELS } from "@/lib/constants";

export function StatusBadge({ status, className }) {
  const key = status || "open";
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium",
        `status-${key}`,
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {STATUS_LABELS[key] || key}
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  const key = priority || "medium";
  return (
    <span
      data-testid={`priority-badge-${key}`}
      className={cn(
        "inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider",
        `priority-${key}`,
        className,
      )}
    >
      <span className="h-1 w-1 rounded-full bg-current" />
      {PRIORITY_LABELS[key] || key}
    </span>
  );
}
